import { StyleSheet } from 'react-native'
import styled from 'styled-components/native'

import { ApplicationStyles } from 'APP/Themes'

export const Overlay = styled.View.attrs({
  style: StyleSheet.absoluteFill,
})(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.01)',
}))

export const InnerBox = styled.View.attrs({
  style: ApplicationStyles.shadow,
})(({ theme }) => ({
  width: 200,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 15,
  borderRadius: 15,
  marginBottom: theme.metrics.statusBarHeight + theme.metrics.screenHeight / 14,
  backgroundColor: theme.colors.elementsBg,
}))

export const LoadingText = styled.Text(({ theme }) => ({
  color: theme.colors.text,
  paddingTop: 15,
  paddingBottom: 5,
}))

export const Spinner = styled.ActivityIndicator.attrs(({ theme }) => ({
  size: 'large',
  color: theme.colors.text,
}))({
  alignSelf: 'center',
  margin: 15,
})
